import React from "react";
import { Button, Dropdown } from "antd";
import type { MenuProps } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import "./RowActionsMenu.css";

interface RowActionsMenuProps {
  items: MenuProps["items"];
  ariaLabel: string;
  loading?: boolean;
  overlayClassName?: string;
}

const RowActionsMenu: React.FC<RowActionsMenuProps> = ({
  items,
  ariaLabel,
  loading = false,
  overlayClassName = "",
}) => {
  const visibleItems = items?.filter(Boolean) as MenuProps["items"];

  const stopRowClick: React.MouseEventHandler<HTMLElement> = (event) => {
    event.stopPropagation();
  };

  const stopMenuClick: MenuProps["onClick"] = ({ domEvent }) => {
    // Ant Design rend le menu dans un portail. Sans cette protection, le clic
    // synthétique peut remonter jusqu'au onClick de la ligne du tableau.
    domEvent.stopPropagation();
  };

  if (!visibleItems?.length) {
    return null;
  }

  return (
    <span className="row-actions-menu" onClick={stopRowClick}>
      <Dropdown
        menu={{ items: visibleItems, onClick: stopMenuClick }}
        trigger={["hover", "click"]}
        placement="bottomRight"
        overlayClassName={["row-actions-menu__dropdown", overlayClassName].filter(Boolean).join(" ")}
        mouseEnterDelay={0.12}
      >
        <Button
          type="text"
          size="small"
          icon={<MoreOutlined />}
          loading={loading}
          className="row-actions-menu__trigger"
          aria-label={ariaLabel}
          title="Actions"
        />
      </Dropdown>
    </span>
  );
};

export default RowActionsMenu;
